import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import certifications from "../assets/certifications.json";
import certificate from "../assets/certificate.svg";
import { FiExternalLink } from "react-icons/fi";
import achievement from "../assets/achievements.svg";
import certificate1 from "../assets/certifications/Almabetter Full Stack Web Development.png";
import experience from "../assets/experience.svg";
import experiencedata from "../assets/experience.json";
import { GoVerified } from "react-icons/go"
import badge from "../assets/badge.png";
import BackToTop from './BackToTop';

export default function Experience() {
  document.title = "Experience | Krupali Desai";
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);
  const animations = {
    div: {
      initial: {
        y: '40%',
        opacity: 0
      },
      whileInView: {
        y: '0',
        opacity: 1
      },
      transition: {
        duration: 0.5,
      }
    },
    headdiv: {
      initial: {
        y: '40%',
        opacity: 0
      },
      whileInView: {
        y: '0',
        opacity: 1
      },
      transition: {
        duration: 0.5,
      }
    },
  }

  return (
    <div className='experience'>
      <div className="experiencesection">
        <motion.div {...animations.headdiv} className="head">
          <img src={experience} alt="" />
          <h1>Experience</h1>
        </motion.div>
        <div className="timeline">
          <motion.div {...animations.div} className="timelinebox">
            {
              experiencedata['experience: '].map((item, index) => (
                <TimeLineItem key={index} title={item.company} position={item.position} from={item.from} description={item.description} url={item.url} />
              ))
            }
          </motion.div>
        </div>
      </div>
      <div className="achievementsection">
        <motion.div {...animations.headdiv} className='head'>
          <h1>Achievements</h1>
          <img src={achievement} alt="" />
        </motion.div>
        <motion.div {...animations.div} className='achievementcertificateholder'>
          <img src={certificate1} alt="" />
          <div className="info">
            <img src={badge} alt="" />
            <h2>Certified Full Stack Web Developer With Web 3.0 From Almabetter</h2>
            <p>🎉 I am thrilled to announce that I have successfully earned a <b>Full Stack Web Developer certificate</b> from Almabetter! 🌟 Throughout my journey, I immersed myself in the fascinating world of web development, mastering a range of technologies and frameworks. 💪

🌐 I sharpened my skills in <b>HTML</b>, <b>CSS</b>, and <b>JavaScript</b>, crafting captivating and responsive user interfaces. 💻 Additionally, I dived into the realm of server-side programming with <b>Node.js</b> and delved into data management using <b>MongoDB</b>.

⚛️ The world of frontend frameworks beckoned, and I eagerly embraced <b>Angular</b> and <b>React.js</b>. These powerful tools allowed me to build dynamic and interactive web applications that captivate users.

🚀 Equipped with a diverse tech stack and expertise in MongoDB, Angular, React.js, and Node.js, I am now ready to tackle complex challenges in the web development landscape. 🌈 I am excited to embark on new opportunities, creating remarkable digital experiences that leave a lasting impact. Let's build the future together! 🌍💻</p>
            <a href="https://certificates.almabetter.com/en/verify/64521719580394" target='blank' rel='noopener noreferrer' >See My Certificate<FiExternalLink/></a>
          </div>
        </motion.div>
      </div>
      <div className='certificationsection'>
        <motion.div {...animations.headdiv} className='head'>
          <img src={certificate} alt="" />
          <h1>Certifications</h1>
        </motion.div>
        <div className="certificateholder">
          {
            certifications.certifications.map((certificate, index) => {
              return (
                <motion.div {...animations.div} className='certificatecard' key={index}>
                  <img src={certificate.imgSrc} alt={certificate.title} />
                  <h3>{certificate.title}</h3>
                  <p>Issued By: {certificate.issuer}</p>
                  <a href={certificate.imgSrc} target='blank' rel='noopener noreferrer'>Show Credential  <FiExternalLink /></a>
                </motion.div>
              )
            }
            )}
        </div>
      </div>
            <BackToTop />
    </div>
  )
}


const TimeLineItem = ({ title, position, from, description, url }) => (
  <div className={'timelineitem'}>
    <h2>{position}  <GoVerified /></h2>
    <h3>{title} <a href={url} target='_blank' rel='noopener noreferrer'><FiExternalLink /></a></h3>
    <p>Dated: <b>{from}</b></p>
    <p>{description}</p>
  </div>
)